import { execSync } from 'child_process';
import chalk from 'chalk';

export async function updateCommand(): Promise<void> {
  console.log(chalk.blue('  ⠋ 업데이트 확인 중...'));

  try {
    // npm에서 최신 버전 확인
    const latest = execSync('npm view @intellicore/cli version 2>/dev/null', {
      encoding: 'utf-8',
    }).trim();

    const current = typeof __VERSION__ !== 'undefined' ? __VERSION__ : '0.1.0';

    if (latest === current) {
      console.log(chalk.green(`  ✓ 이미 최신 버전입니다 (v${current})`));
      return;
    }

    console.log(chalk.yellow(`  현재: v${current} → 최신: v${latest}`));
    console.log(chalk.blue('  ⠋ 업데이트 중...'));

    execSync('npm install -g @intellicore/cli@latest', {
      encoding: 'utf-8',
      stdio: 'pipe',
    });

    console.log(chalk.green(`  ✓ v${latest}로 업데이트 완료`));
    console.log(chalk.dim('  변경사항: https://github.com/SolomonJongmin/intellicore-cli/releases'));
  } catch (err: any) {
    // npm 패키지가 아직 publish 안 된 경우 → git pull 방식
    try {
      console.log(chalk.dim('  npm 패키지 미등록 — git pull로 업데이트 시도...'));
      const output = execSync('git pull origin main', {
        encoding: 'utf-8',
        cwd: getInstallDir(),
      });
      console.log(chalk.dim(`  ${output.trim()}`));

      execSync('npm install && npm run build', {
        encoding: 'utf-8',
        cwd: getInstallDir(),
        stdio: 'pipe',
      });

      console.log(chalk.green('  ✓ 업데이트 완료 (git pull + rebuild)'));
    } catch (gitErr: any) {
      console.error(chalk.red(`  ✗ 업데이트 실패: ${gitErr.message}`));
      console.log(chalk.dim('  수동 업데이트: cd <설치경로> && git pull && npm run build'));
    }
  }
}

declare const __VERSION__: string;

function getInstallDir(): string {
  try {
    const path = execSync('which intellicode', { encoding: 'utf-8' }).trim();
    // /usr/local/bin/intellicode → 심링크 따라가서 프로젝트 루트 추출
    const realPath = execSync(`readlink -f ${path}`, { encoding: 'utf-8' }).trim();
    // dist/cli.js → 상위 2단계
    return realPath.replace(/\/dist\/.*$/, '');
  } catch {
    return process.cwd();
  }
}
